import ScrollEvent = JQuery.ScrollEvent;

const $body = $('body');

let lastScrollPos: number = window.scrollY,
    //delta scroll
    isTouchDevice: boolean = false,
    delta: number = 0,
    scrollCheckInterval: any,
    menu = $(".header .menu"),
    chatElement = $('#chat-toggle-button'),
    bannersToShow: JQuery[] = [];
function onScroll(this: Window) {
    // $this - window
    const $this = $(this);
    scrollShowMenu();
    if ($this.width()! > 1520 && !$body.hasClass('block-scroll')) {
        if ($this.scrollTop()! > 200) {
            $('#to-top').addClass('visible');
        } else {
            $('#to-top').removeClass('visible');
        }
    }
    //click on comments button when scrolled to it

    const showCommentsButton = $('.more-comments:not(.hidden):not(.blocked):not(.load-manyaly)');
    if(showCommentsButton[0] && showCommentsButton.isInViewport())
        showCommentsButton.trigger('click');
    bannersToShow.forEach(banner=>{
        if(banner.isInViewport()) banner.addClass('shown');
        else banner.removeClass('shown');
    })
    //in theory, it could not be loaded
    if(!menu[0]) menu = $(".header .menu");
    if(!chatElement[0]) chatElement = $('#chat-toggle-button');
    if($this.height()! - menu.position().top < 100 && isTouchDevice) {
        menu.css('transition', '')
        chatElement.css('transition', '0s')
        // bottom menu detected, hide it on scroll
        scrollMenu();
        lastScrollPos = window.scrollY;
    }
    else menu.css('transform', 'none')
}
let liveSearch = $('none');
$(()=>{
    liveSearch=$('.search-block-wrapper:eq(1)').find('.live-search-wrapper')
    bannersToShow = Array.from($('.sub-banner')).map(e=>$(e));
});
function scrollShowMenu() {
    const menuHeader = $('header.header');
    if ($(document).scrollTop()! >= 250) {
        if (!menuHeader.hasClass('fixed')) {
            menuHeader.addClass('fixed').delay(10).queue(function () {
                $(this).addClass('show').dequeue();
            });
            liveSearch.hide();
        }
    } else if (menuHeader.hasClass('fixed')) {
        menuHeader.removeClass('fixed').removeClass('show');
        liveSearch.show();
    }
}

//to top button
$(window)
    .on('scroll', onScroll)
    .on('touchstart', ()=>{isTouchDevice=true;scrollCheckInterval = undefined;})
    .on('touchend', ()=>{
        //check if user still scrolling
        let currentScroll = window.scrollY;
        const interval = scrollCheckInterval = setInterval(()=>{
            if(scrollCheckInterval !== interval) clearInterval(interval);
            else if(window.scrollY == currentScroll){
                clearInterval(interval);
                onEndScroll();
            }
            currentScroll = window.scrollY;
        }, 50);

    })
function scrollMenu(){
    delta = (window.scrollY - lastScrollPos)*.8;
    const transformOld = menu.data('transform') || 0;
    let transform = transformOld + delta
    if(transform < 0) transform = 0;
    if(transform > menu.height()!) transform = menu.height();
    menu.css('transform', `translateY(${transform}px)`)
        .data('transform', transform);
    chatElement.css('transform', `translateX(${transform*.8}px)`)
}
function onEndScroll(){
    const currentPos = menu.data('transform'),
        maxScroll = menu.height()!;
    if((currentPos<=maxScroll && (delta > 0 || (currentPos+20)>maxScroll) && currentPos>20) && window.scrollY >=20){
        const transitionTime = (maxScroll-currentPos)/200+"s";
        menu.css('transition', transitionTime)
            .css('transform', `translateY(${maxScroll}px)`)
            .data('transform', menu.height()!);
        chatElement.css('transition', transitionTime)
            .css('transform', `translateX(${maxScroll*.8}px)`);
    }
    else{
        const transitionTime = currentPos/200+"s";
        menu.css('transition',transitionTime)
            .css('transform', 'translateY(0)')
            .data('transform', 0);
        chatElement.css('transition', transitionTime)
            .css('transform', `translateX(0)`);

    }
    delta = 0;
}

$(()=>{
    if($('.top')[0])
        onScroll.call(window);
});

export {};